/**
 * Green Flag — UpcomingEligibleWidget slot recipe
 *
 * Vertical featured card for an upcoming event the user is eligible for.
 * Full-width hero image on top, date / title / Sparks chip / full-width
 * sign-up button stacked below.
 */

import { defineSlotRecipe } from "@chakra-ui/react";

export const upcomingEligibleWidgetRecipe = defineSlotRecipe({
  className: "gf-upcoming-eligible",
  slots: ["root", "image", "body", "date", "title", "sparks", "signUp"],

  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      bg: "bg.canvas",
      borderRadius: "sm",
      overflow: "hidden",
      boxShadow: "card",
      cursor: "pointer",
      transitionProperty: "transform, filter",
      transitionDuration: "fast",
      _hover: { filter: "brightness(1.02)" },
      _active: { transform: "translateY(0.5px)" },
    },
    image: {
      w: "full",
      h: "auto",
      display: "block",
      bg: "border.default",
    },
    body: {
      px: "5",
      pt: "4",
      pb: "5",
      display: "flex",
      flexDirection: "column",
      gap: "2",
    },
    date: {
      textStyle: "eyebrow",
      color: "fg.default",
    },
    title: {
      fontFamily: "body",
      fontWeight: "semibold",
      fontSize: "2xl",
      lineHeight: "tight",
      color: "fg.default",
    },
    sparks: {
      mt: "1",
    },
    signUp: {
      mt: "3",
      w: "full",
      h: "44px",
      borderRadius: "full",
      bg: "bg.brand",
      color: "fg.onBrand",
      fontFamily: "body",
      fontWeight: "bold",
      fontSize: "sm",
      letterSpacing: "wide",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
      cursor: "pointer",
      transition: "transform 120ms ease, filter 120ms ease",
      _hover: { filter: "brightness(1.04)" },
      _active: { transform: "scale(0.96)" },
    },
  },
});
